export default {
  "ui:order": ["file_type", "file"],
  file_type: {
    "ui:title": "Document Type",
  },
  file: {
    "ui:title": "Select File",
    "ui:widget": "file-input",
  },
};
